import React, { useEffect, useState, useRef} from "react";
import { Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { Image } from "react-bootstrap";

import { FileService } from "src/utils/file.service";
import Button from "src/components/button";
import { fetchAnswerForSeek, invalidateSeekSession} from "src/redux/actions/seek";
import { fetchSeekLimit } from 'src/legacy/redux/actions/search';
import SeekSearch from "src/pages/seek/components/seekSearch";
import { localizedStrings } from 'src/localization';

import _ from "lodash";
import cx from "classnames";
import styles from "./styles.module.scss";
import Text from "src/components/text";

export default function SearchContainer(props) {
  const dispatch = useDispatch();
  const previousQueryRef = useRef("");

  const localizedCommons = localizedStrings.commons;
  const localizedSearch = localizedStrings.pages.search;
  const localizedSeek = localizedStrings.pages.seek;
  const account = useSelector((state) => _.get(state, 'accounts.item'));
  const isSeekEnabled = _.get(account, "seekEnabled" , false)
  const streamName = _.get(props, "stream.name", "")

  const seekSession = useSelector((state) => _.get(state, 'seek.session.item'));
  const isSeekLoading = useSelector((state) => _.get(state, 'seek.session.loading'));
  const seekErrors = useSelector((state) => _.get(state, "legacyRootReducer.search.seek.error.errors"));
  const isSeekLimitExceeded = _.find(seekErrors, { code: 20003 }) ? true : false;
  const session = useSelector((state) => _.get(state, 'seek.session'));
  const [seekRedirect, setSeekRedirect] = useState(false);

  const [seekAnswer, setSeekAnswer] = useState("");
  const [query, setQuery] = useState("")
  const [showSeekSearch, setShowSeekSearch] = useState(false);
  const chats = _.get(seekSession, "chats", [])

  const shouldFetchSeekAnswer = (chats, query, props, isSeekLimitExceeded) => {

    if (!isSeekEnabled){
      return false;
    }
    
    const hasLocationQuery = _.get(props, "location.query");
    const hasQuery = _.size(_.get(props, "location.query.query", "")) > 0;

    if (chats.length > 0) {
      const lastChat = chats[chats.length - 1];
      return lastChat && lastChat.question !== query && hasQuery;
    }

    return hasLocationQuery && hasQuery && !isSeekLimitExceeded;
  };

  useEffect(() => {
    dispatch(fetchSeekLimit());
    if (_.size(chats) > 0 && _.size(_.get(props, "location.query.query", "")) > 0) {

      if(!isSeekEnabled) {
        return;
      }

      const totalQuestions = _.size(chats);
      const lastChat = chats[totalQuestions - 1];

      if (lastChat && !lastChat.querying && lastChat.question === _.get(props, "location.query.query")) {
        var answer = "";
        const seekErrors = _.get(lastChat, "error.errors");

        setQuery(lastChat.question)

        if (_.size(lastChat.citations) === 0) {
          setSeekAnswer("");
          return;
        }

        if (_.size(lastChat.answer) > 0) {
          answer = lastChat.answer
        }
        else if (seekErrors) {
          answer = seekErrors[0].message
        }
        else {
          answer = localizedSeek.error_messages.no_response
        }

        if (_.size(answer) > 0) {
          let sentenceArray = answer.split(" ");
          let slicedArray = _.slice(sentenceArray, 0, 70);
          let slicedAnswer = _.join(slicedArray, ' ');
          slicedAnswer = slicedAnswer + "...";
          setSeekAnswer(slicedAnswer);
        }
        else {
          setSeekAnswer("")
        }
        return;
      }
    }

    if (shouldFetchSeekAnswer(chats, query, props, isSeekLimitExceeded)) {
      dispatch(
        fetchAnswerForSeek({
          id: null,
          question: _.get(props, "location.query.query"),
          session: '',
          request: { includeActions: false },
        })
      );
    }

    return (() => {
      setSeekAnswer("");
    })
  }, [])

  useEffect(() => {
    if (query && !seekSession?.id && !seekRedirect) {      
      handleSearchQuery();
    }
  }, [seekSession?.id])

  useEffect(() => {
    const query = _.get(props, "location.query.query", "");
    if (_.size(query) === 0) {
      setSeekAnswer("");
      setQuery("");
    }
  }, [_.get(props, "location.query.query", "")])

  useEffect(() => {
    const query = _.get(props, "query", "");
    if (_.size(query) > 0) {
      setQuery(query)
    }
  }, [_.get(props, "query")])

  useEffect(() => {
    const query = _.get(props, "location.query.query", "");
  
    if (_.size(chats) === 0 || _.size(query) === 0) return;
  
    const totalQuestions = _.size(chats);
    const lastChat = chats[totalQuestions - 1];
  
    if (!lastChat || lastChat.querying) return;
  
    if (_.size(lastChat.citations) === 0) {
      setSeekAnswer("");
      return;
    }
  
    let answer = "";
    const seekErrors = _.get(lastChat, "error.errors");
    setQuery(lastChat.question)
  
    if (_.size(lastChat.answer)) {
          answer = lastChat.answer
        }
        else if (_.get(seekErrors, "[0].code") === 20003) {
      answer = `We understand that you'd like to SEEK more! Unfortunately, you've reached the permissible limit on the SEEK volume.
          Fret not, we're here to assist! Please reach out to your <a className={styles.seekText} href="mailto: support@paperflite.com/">  Customer Success Manager </a> and they'll swiftly bring you back on track!`
        }
        else if (seekErrors) {
          answer = seekErrors[0].message
        }
        else {
          answer = localizedSeek.error_messages.no_response
    }
  
    if (_.size(answer) > 0) {
      let sentenceArray = answer.split(' ');
      let slicedArray = _.slice(sentenceArray, 0, 70);
      let slicedAnswer = _.join(slicedArray, ' ');
      slicedAnswer = slicedAnswer + '...'; // Add ellipsis to show more content
  
      // Regex to find citation tags
      const citationRegex = /<span\s+class=['"]seek__cite['"]\s+data-cite=['"](\d+)['"]>\[\d+\]<\/span>/g;
  
      const uniqueCitations = _.uniqBy(lastChat.citations, 'id');
      const sources = uniqueCitations.map((citation) => {
        const content = lastChat.contents.find(
          (content) => content.id === citation.content.id
        );
        return {
          id: content?.id,
          name: content?.name || '',
          icon: content?.icon?.thumbnail || '',
          metadata: content?.metadata || {},
          page: citation.page,
        };
      });
  
      const transformedParts = [];
      let lastIndex = 0;
      let match;
  
      while ((match = citationRegex.exec(slicedAnswer)) !== null) {
        const citeId = parseInt(match[1], 10);
        const index = match.index;
        const asset = sources[citeId - 1];
  
        if (lastIndex < index) {
          transformedParts.push(slicedAnswer.substring(lastIndex, index));
        }
  
        transformedParts.push(
          <span className={styles.citationNumber} onClick={() => { window.open(`/assets/${asset.id}`, '_blank'); }}>
            <div
              key={`cite-${citeId}-${index}`}
              className={styles.seek__cite}
              rel="noopener noreferrer"
              data-cite={citeId}
            >
              <span className={styles.citationId}>
                {asset.page === -1 ? citeId : asset.page}
              </span>
              <div className={styles.hoverTooltip}>
                <Image className={styles.icon} src={asset?.icon} />
                <div className={styles.assetDetails}>
                  <div className={styles.clampedWrapper}>
                    <Text text={asset?.name} lines={1} className={styles.assetTitle} />
                  </div>
                  <p className={styles.assetMetadata}>
                    {FileService.getFileType(asset.metadata)}{' '}
                    {asset.metadata.pages
                      ? `| ${asset.metadata.pages} pages`
                      : asset.metadata.video_duration
                      ? `| ${Math.ceil(asset.metadata.video_duration / 60)} min`
                      : ''}
                  </p>
                </div>
              </div>
            </div>
          </span>
        );
        lastIndex = citationRegex.lastIndex;
      }
  
        // If there are any remaining parts after the last citation, push them
      if (lastIndex < slicedAnswer.length) {
        transformedParts.push(slicedAnswer.substring(lastIndex));
      }
  
      // Update seekAnswer state with the transformed content
      setSeekAnswer(transformedParts);
    } else {
      setSeekAnswer("");
    }
  }, [isSeekLoading, chats]);
  
  const handleRedirect = () => {
    if(isSeekLimitExceeded){
        dispatch(invalidateSeekSession());
    }  
    setShowSeekSearch(true);
  }

  const handleSearchQuery = (e) => {
    if (e) {
      e.preventDefault();
    }
    
    if(!isSeekEnabled){
      props._handleSearch();
      return;
    }

    if (!isSeekLoading) {
      setSeekAnswer("")
      if (_.size(query) === 0) {
        dispatch(invalidateSeekSession());
      }
      if (_.size(query) > 0 && !isSeekLimitExceeded) {
        previousQueryRef.current = query;
        dispatch(
          fetchAnswerForSeek({
            id: null,
            question: query,
            session: '',
            request: {
              includeActions: false,
            }
          }),
        );
      }
      props._handleSearch();
    }
  }
  
  const handleClearQuery = () => {
    setQuery("")
    props.clearValue();
  }

  return (
    <>
    <Col sm={12} className={cx(styles.column, styles.searchBar)}>
      <form onSubmit={handleSearchQuery}>
        <div className={styles.inputContainer}>
          <Col sm={11} xs={12} className={cx(styles.noPadding)}>
            <div className={styles.search}>
              <label>
                {props.isFromStream && <span className={styles.tagName}> 
                  {streamName && <Text className={styles.streamTag} text={`in: ${streamName}`} lines={1} />}             
                  </span>}
                {props.isFromHub && <span className={cx(styles.tagName, styles.block)}> {localizedSearch.in_hub}</span>}
                <input
                  type="text"
                  name="search"
                  value={props.query}
                  placeholder={localizedCommons.search_placeholder}
                  onChange={(e) => {
                    props._onQueryChange(e)
                    setQuery(e.target.value)
                  }}
                />
                {_.size(props.query) > 0 && <i onClick={handleClearQuery} className={cx("paperflite-close", styles.clearIcon)} />}
              </label>
            </div>
          </Col>
          <Col sm={2} xsHidden className={styles.columnAction}>
            <Button icon="paperflite-search"
              text={localizedCommons.actions.search}
              variant='primary'
              disabled={false}
              onClick={handleSearchQuery}
            />
          </Col>
        </div>

        {(isSeekLoading || seekAnswer) && <div className={styles.seekResponseContainer}>
          {isSeekLoading &&
            <p className={styles.loadingContainer}>
              <span className={styles.iconContainer}><img src="/images/seek.gif" /></span>
              <span className={styles.loading}>{localizedSearch.loading.seek_response}...</span>
            </p>}

          {!isSeekLoading && seekAnswer &&
            <p className={styles.responseContainer}>
              <span className={styles.overviewSeek}>
                <img src="/images/seek.gif" />
                <p className={styles.name}>Curated by Seek</p>
              </span>

              <div id="response" style={{ lineHeight: "25px" }} className={styles.seekResponse}>
                <span className={styles.response}>{seekAnswer}</span>
              </div>
            </p>
          }

          {!isSeekLoading && seekAnswer && 
            <span className={styles.redirect}
            onClick={() => {
              handleRedirect();
              setSeekRedirect(true);
              }}>
            <i className={'paperflite-right-arrow'} />{" "}
            {isSeekLimitExceeded ? localizedSearch.actions.go_to_seek : "See full response"} </span>}
        </div>
        }
      </form>
    </Col>
    {showSeekSearch && (
      <SeekSearch
        seekAnswer={seekAnswer}
        onClose={() => {
          setShowSeekSearch(false);
          setSeekRedirect(false);
          const previousQuery = previousQueryRef.current;
          if (_.size(previousQuery) > 0) {
            setQuery(previousQuery);
            props._onQueryChange({ target: { value: previousQuery } });
          }
        }}
      />
    )}
    </>

  )
}